<template>
  <div class="footer">
    <div class="block">
      <div class="top">
        <div class="item">
          <span>{{ $t("好") }}</span>
          <div class="title">
            <div class="subtitle">{{ $t("海量现货") }}</div>
            <div class="desc">
              <div>{{ $t("40万现货SKU") }}</div>
              <div>{{ $t("品类不断扩充") }}</div>
            </div>
          </div>
        </div>
        <div class="item">
          <span>{{ $t("快") }}</span>
          <div class="title">
            <div class="subtitle">{{ $t("闪电发货") }}</div>
            <div class="desc">
              <div>{{ $t("科技智能大仓储") }}</div>
              <div>{{ $t("4小时快速交货") }}</div>
            </div>
          </div>
        </div>

        <div class="item">
          <span>{{ $t("好") }}</span>
          <div class="title">
            <div class="subtitle">{{ $t("严控渠道") }}</div>
            <div class="desc">
              <div>{{ $t("仅从原厂和代理商进货") }}</div>
              <div>{{ $t("每一颗料均可原厂追溯") }}</div>
            </div>
          </div>
        </div>
        <div class="item">
          <span>{{ $t("省") }}</span>
          <div class="title">
            <div class="subtitle">{{ $t("降低成本") }}</div>
            <div class="desc">
              <div>{{ $t("明码标价节省时间成本") }}</div>
              <div>{{ $t("一站式采购正品元器件") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="help" v-if="language === 'zh'">
      <div class="mod_help_list">
        <div class="mod_help_nav_zh" v-for="(v, i) in selfList" :key="i">
          <h5 class="mod_help_nav_tit">{{ v.name }}</h5>
          <ul class="mod_help_nav_con">
            <li v-for="(item, index) in v.content" :key="index">
              <div
                v-if="item.title"
                style="font-size: 12px;font-weight: 400;color: #747474;cursor: pointer;"
                @click="goPage(item, v)"
              >
                {{ item.title }}
              </div>
              <!-- <div
                v-else-if="item.title_en"
                style="font-size: 12px;font-weight: 400;color: #747474;cursor: pointer;"
                @click="goPage(item, v)"
              >
                {{ item.title_en }}
              </div>
              <div
                v-else
                style="font-size: 12px;font-weight: 400;color: #747474;cursor: pointer;"
                @click="goPage(item, v)"
              >
                {{ item.title_ru }}
              </div> -->
            </li>
          </ul>
        </div>
        <div style="display:flex ;" class="">
          <div class="concat" style="padding-right:10px">
            <div class="title">{{ $t("联系我们") }}</div>
            <div class="phone" style="font-size: 21px;">{{ contact.web_tel }}</div>
            <div class="qq">{{ $t("企业QQ") }}：{{ contact.web_qq }}</div>
            <div class="time">
              <span>{{ $t("服务时间：24小时在线") }}</span>
              <!-- <div>
            <span>{{contact.service_time_work}}</span>
            <span>{{contact.service_time_rest}}</span>
          </div> -->
            </div>
          </div>
          <div>
            <img :src="$jx.oss(guanggaoList11.img)" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="help" v-else>
      <div class="mod_help_list">
        <div class="mod_help_nav" v-for="(v, i) in selfList" :key="i">
          <h5 class="mod_help_nav_tit">{{ v.name }}</h5>
          <ul class="mod_help_nav_con">
            <li v-for="(item, index) in v.content" :key="index">
              <!-- <div
                v-if="item.title"
                style="font-size: 12px;font-weight: 400;color: #747474;cursor: pointer;"
                @click="goPage(item, v)"
              >
                {{ item.title }}
              </div> -->
              <div
                v-if="item.title_en"
                style="font-size: 12px;font-weight: 400;color: #747474;cursor: pointer;"
                @click="goPage(item, v)"
              >
                {{ item.title_en }}
              </div>
              <div
                v-else
                style="font-size: 12px;font-weight: 400;color: #747474;cursor: pointer;"
                @click="goPage(item, v)"
              >
                {{ item.title_ru }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      
    </div>
    <div style="" class="help" v-if="language !== 'zh'">
        <div class="concat">
          <div class="title">{{ $t("联系我们") }}</div>
          <div class="phone">{{ contact.web_tel }}</div>
          <div class="qq">{{ $t("企业QQ") }}：{{ contact.web_qq }}</div>
          <div class="time">
            <span>{{ $t("服务时间：24小时在线") }}</span>
          </div>
        </div>
        <div>
          <img :src="$jx.oss(guanggaoList11.img)" alt="" />
        </div>
      </div>

    <div class="copyright">
      © {{ $t("2011-2022 骏芯有限公司 版权所有") }}
      <span @click="goPageJs()" style="cursor: pointer;">{{
        contact.beian
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  data() {
    return {
      language: "",
      selfList: [],
      infoList: [],
      contact: {},
      guanggaoList11: {}
    };
  },
  created() {
    let language = localStorage.getItem("language");
    console.log('language',language);
    if(!language) {
      localStorage.setItem("language", 'zh');
    }
    this.language = localStorage.getItem("language");
  },
  mounted() {
    this.getSelf();
    setTimeout(() => {
      this.contact = JSON.parse(localStorage.getItem("jx:common")).data;
    }, 1000);
  },
  methods: {
    goPageJs() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    goPage(item, v) {
      if (item.id == 999) {
        this.$router.push({ name: "volumeIndex" });
        return;
      }
      this.$router.push({
        name: "newsInfo",
        params: { id: item.id, title: item.title, name: v.name }
      });
      this.reload();
    },
    getSelf() {
      this.$http.get("/wanlshop/Article/adList", {}).then(
        res => {
          let data = res.data;
          data.forEach(it => {
            if (it.id == 11) {
              this.guanggaoList11 = {
                img: it.media,
                gourl: it.url
              };
            }
          });
        },
        err => {}
      );

      this.$http.get("/wanlshop/news/webbottom", {}).then(
        res => {
          this.selfList = res.data;
          this.selfList[1].content.push({
            id: 999,
            title: this.$t("领券中心")
          });
          this.selfList[this.selfList.length - 1].content.push({
            id: -1,
            title: this.$t("意见反馈")
          });
        },
        err => {
          console.log(err);
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;

  ul li {
    list-style: none;
    font-size: 20px;
  }

  .block {
    border-bottom: 1px solid #e1e1e1;

    .top {
      min-width: 1200px;
      max-width: 1200px;
      margin: 30px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item {
        /* width: 25%; */
        display: flex;
        /* justify-content: flex-start; */
        align-items: baseline;
        box-sizing: border-box;
        position: relative;
        padding-left: 40px;

        &:first-child {
          padding-left: 40px;
        }

        &:last-child {
          justify-content: flex-end;
          // padding-right: 40px;
        }

        &:nth-child(2),
        &:nth-child(3) {
          justify-content: center;
        }

        span {
          display: inline-block;
          width: 40px;
          height: 40px;
          color: #0094e7;
          border: 2px solid #0094e7;
          border-radius: 50%;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          font-weight: bold;
          position: absolute;
          left: 0;
        }

        .title {
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;

          .subtitle {
            color: #444444;
            font-size: 20px;
            font-weight: bold;
          }
        }

        .desc {
          color: #666666;
          font-size: 10px;
          margin-top: 2px;
          transform: scale(0.8);
        }
      }
    }
  }

  .help {
    min-width: 1200px;
    max-width: 1200px;
    margin: 25px auto;
    display: flex;
    justify-content: space-between;

    .mod_help_list {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      .mod_help_nav {
        width: calc(100% / 6);
        // text-align: center;

        // &:last-child {
        //   .mod_help_nav_tit {
        //     border-right: 1px solid #e1e1e1;
        //   }

        //   .mod_help_nav_con {
        //     border-right: 1px solid #e1e1e1;
        //   }
        // }

        .mod_help_list_zh {
          width: calc(100% / 8);
        }

        h5 {
          font-size: 14px;
          color: #666666;
          font-weight: bold;
        }

        li {
          padding: 2px 0;

          a {
            font-size: 12px;
            color: #666666;
            text-decoration: none;
          }
        }
      }
      .mod_help_nav_zh {
        width: calc(100% / 8);
      }
    }

    .concat {
      // width: 25%;
      // padding: 0 20px;
      box-sizing: border-box;

      .title {
        color: #666666;
        font-size: 14px;
        font-weight: bold;
      }

      .phone {
        color: #199ee8;
        font-size: 30px;
        font-weight: bold;
        margin-top: 4px;
      }

      .qq {
        color: #666666;
        font-size: 12px;
        margin: 10px 0;
      }

      .time {
        color: #666666;
        font-size: 12px;
        display: flex;
        justify-content: flex-start;

        > div {
          display: flex;
          flex-direction: column;

          span {
            margin-bottom: 4px;
          }
        }
      }
    }
  }

  .copyright {
    background-color: #c7c7c7;
    color: #6e6e6e;
    font-size: 12px;
    text-align: center;
    padding: 6px 0;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue